import * as React from 'react';

import { calculateBalanceBoundaries } from '../../utils/balances';
import { formatSinceText } from '../../utils/formatting';

import ChangeIndicator from './ChangeIndicator';

import type { CalendarDateRange } from '../DateRangePicker';
import type { ColumnTable } from 'arquero';

export interface IBalanceChangeIndicatorDataPoint {
  period: string; // YYYY-MM-DD format
  balance: number;
}

export interface IBalanceChangeIndicatorProps {
  transactions: ColumnTable | null;
  currentBalance: number;
  dateRange: CalendarDateRange;
  className?: string;
}

const BalanceChangeIndicator = ({
  transactions,
  currentBalance,
  dateRange,
  className,
}: IBalanceChangeIndicatorProps) => {
  const { balanceAtStart } = React.useMemo(
    () =>
      calculateBalanceBoundaries({
        transactions,
        currentBalance,
        dateRange,
      }),
    [transactions, currentBalance, dateRange]
  );

  // Format the versus text to show the start date
  const versusText = React.useMemo(() => {
    return formatSinceText(dateRange.start);
  }, [dateRange]);

  return (
    <ChangeIndicator
      current={currentBalance}
      previous={balanceAtStart}
      versusText={versusText}
      increaseGood={true}
      className={className}
    />
  );
};

export default BalanceChangeIndicator;
